const Cookie = require('./Cookie');

module.exports = class UserStatus {
    static getUserName = () => {
      const userName = Cookie.get('UserName', 'MISCGCs') || Cookie.get('UserName');
      return userName;
    }

    static isSecureUserTokenAlive = () => {
      const tokenExpiry = Number(Cookie.get('STExpiry', 'MISCGCs'));
      return Date.now() < tokenExpiry;
    }

    static isSignedIn = () => (Cookie.get('SignedIn') === '1' && this.isSecureUserTokenAlive())

    static isSoftSignedIn = () => (this.getUserName() && !this.isSignedIn())

    static isNewSoftSignedIn = () => this.isSoftSignedIn()
};
